/**
 * No Operation, Function that does nothing
 */
export function noop(): void {}
